import { render } from "./CS_xweather.vue?vue&type=template&id=35d7ad43"
import script from "./CS_xweather.vue?vue&type=script&lang=js"
export * from "./CS_xweather.vue?vue&type=script&lang=js"

import "./CS_xweather.vue?vue&type=style&index=0&id=35d7ad43&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__